import type { FC } from 'react';
import { Badge, Flex } from '@george-labs.com/design-system';

import { t } from '@luna/i18n';

import type { ContactItemPropTypes } from './ContactSelectService';

interface Props {
    item: ContactItemPropTypes;
}

export const ContactSelectItem: FC<Props> = ({ item }) => {
    if (!item.isInvalid) {
        return <span data-cy="contact-item">{item.label}</span>;
    }

    return (
        <Flex
            data-cy="contact-item-invalid"
            justify="space-between"
            align="center"
            className="w-100"
        >
            {item.label}
            <Badge data-cy="invalid-contact-badge" variant={Badge.VARIANT.WARNING}>
                {t('contactDataManagement.invalidContactBadge')}
            </Badge>
        </Flex>
    );
};
